import { Box, Skeleton, Text, Tooltip } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { useFindCustomerFeature } from '@features';
import { selectCustomerEmail, selectCustomerName, selectNavigation, useAppSelector } from '@state';

export const TitleBar = () => {
	const customerName = useAppSelector(selectCustomerName);
	const customerEmail = useAppSelector(selectCustomerEmail);
	const appNav = useAppSelector(selectNavigation);
	const findCustomer = useFindCustomerFeature();
	const [isComponentLoaded, setIsComponentLoaded] = useState(customerName !== '');
	const tooltip = 'to select a customer...';

	useEffect(() => {
		if (customerName !== '') {
			setIsComponentLoaded(true);
		}
	}, [customerName]);

	// A failed CRM contact lookup leaves customerEmail blank (or, before this fix, undefined) -- fall back to the email the design was actually opened with so the header never renders completely empty (GitHub #454).
	const displayEmail = customerEmail?.trim() ? customerEmail : (appNav.email ?? '');

	return (
		<Box
			w={'100%'} h={'40px'} border={'0'} textAlign="left" pt="5px"
			cursor={findCustomer.hidden ? 'default' : 'pointer'}
			onClick={findCustomer.hidden ? undefined : findCustomer.handler}
		>
			<Skeleton isLoaded={isComponentLoaded} display="flex" flexDirection="column">
				<Tooltip
					hasArrow
					label={tooltip}
					aria-label={tooltip}
					openDelay={250}
					arrowSize={15}>
					<Text fontSize="xl" as="b" lineHeight="1.4em">{customerName}</Text>
				</Tooltip>
				<Text fontSize="sm" as="i">{displayEmail}</Text>
			</Skeleton>
		</Box>
	);
};
